export default class Model {
    toJSON() {
        return {...this};
    }
}
